import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import AmColumnAndLineChart from '../../../../../commonComponents/charts/AmColumnAndLineChart';

function ActiveSubscriptions({ t, data }) {
  const isEmpty = !data || data.length === 0;

  if (isEmpty) {
    return (
      <div className="pureliink-chart-card">
        <h4 className="career-section-title">
          {t('pureliink.career.overview.activeSubscriptions')}
        </h4>
        <p className="hint-text">
          {t('pureliink.career.overview.noActiveSubscriptions')}
        </p>
      </div>
    );
  }

  const isMultiYear = (() => {
    if (data.length < 2) return false;
    return data[0].year !== data[data.length - 1].year;
  })();

  const fmtDate = item =>
    isMultiYear
      ? `${item.dayOfMonth}/${item.month}/${item.year}`
      : `${item.dayOfMonth}/${item.month}`;

  const chartData = data.map(item => ({
    label: fmtDate(item),
    va: item.va ?? 0,
    subscriptions: item.subscriptions ?? 0,
  }));

  return (
    <div className="pureliink-chart-card">
      <h4 className="career-section-title">
        {t('pureliink.career.overview.activeSubscriptions')}
      </h4>
      <p className="hint-text">
        {t('pureliink.career.overview.activeSubscriptionsHint')}
      </p>

      <AmColumnAndLineChart
        chartId="pureliink-active-subscriptions"
        containerClass="m-chart-container"
        type="columnAndLine"
        stats={chartData}
        options={{
          category: 'label',
          yLabel: 'VA',
          columnValueKey: 'va',
          columnSeriesName: t('pureliink.career.overview.vaGenerated'),
          lineValueKey: 'subscriptions',
          lineSeriesName: t('pureliink.career.overview.subscriptions'),
        }}
      />
    </div>
  );
}

ActiveSubscriptions.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      dayOfMonth: PropTypes.number,
      month: PropTypes.number,
      year: PropTypes.number,
      va: PropTypes.number,
      subscriptions: PropTypes.number,
    }),
  ),
};

ActiveSubscriptions.defaultProps = {
  data: [],
};

export default translate(ActiveSubscriptions);
